import { render } from "./PortfolioPage.vue?vue&type=template&id=4a53c94e"
const script = {}

import "./PortfolioPage.vue?vue&type=style&index=0&id=4a53c94e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__